<template>
  <div class="app-main">
    <keep-alive>
      <router-view />
    </keep-alive>
    <official-website-bottom />
  </div>
</template>

<script>
import OfficialWebsiteBottom from '@/components/OfficialWebsiteBottom.vue'

export default {
  components: { OfficialWebsiteBottom },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.app-main{
  overflow-y: hidden;
}
</style>
